"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _utils = require("../../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function TextInput(_ref) {
  var {
    formik,
    config
  } = _ref;
  var {
    name,
    labelText,
    required,
    className,
    inputMask,
    maxLength,
    placeholderText
  } = config;
  var maxLengthAttribute = maxLength ? {
    maxLength
  } : '';
  var customChange = e => {
    // Regex for First Name
    if (inputMask === 'firstName') {
      e.target.value = e.target.value.replace(/[^A-Za-z0-9 ._'-]/g, '');
    } else if (inputMask === 'lastName') {
      e.target.value = e.target.value.replace(/[^A-Za-z0-9 ._'-]/g, '');
    } else if (inputMask === 'residentialAddress') {
      e.target.value = e.target.value.replace(/[^A-Za-z0-9 .,#_'-]/g, '');
    } else if (inputMask === 'city') {
      e.target.value = e.target.value.replace(/[^A-Za-z .'-]/g, '');
    } else if (inputMask === 'phone') {
      var number = e.target.value;
      var res = '';
      if ((0, _utils.isRealValue)(number)) {
        number = number.replace(/\D/g, '');
        if (number.length) {
          var splitter = /.{1,3}/g;
          number = number.substring(0, 10);
          res = number.substring(0, 7).match(splitter).join('-') + number.substring(7);
        }
      }
      e.target.value = res;
    } else if (inputMask === 'date') {
      var _number = e.target.value;
      var _res = '';
      if ((0, _utils.isRealValue)(_number)) {
        _number = _number.replace(/\D/g, '');
        if (_number.length) {
          var _splitter = /.{1,2}/g;
          _number = _number.substring(0, 8);
          _res = _number.substring(0, 5).match(_splitter).join('/') + _number.substring(5);
        }
      }
      e.target.value = _res;
    } else if (inputMask === 'zip') {
      e.target.value = e.target.value.replace(/[^0-9]/g, '');
      if (e.target.value.length > 5) {
        // take first 5 numbers, add a dash and then put last 4 numbers of zip
        e.target.value = "".concat(e.target.value.substring(0, 5), "-").concat(e.target.value.substring(5, e.target.value.length));
      }
    }
    formik.handleChange(e);
  };
  var showError = formik.errors[name] && formik.touched[name];
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "".concat(className, " form-group")
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.FormInput, _extends({
    id: "ccpa-".concat(name, " input-group"),
    className: "".concat(showError ? 'is-invalid' : ''),
    labelText: labelText,
    name: name,
    value: formik.values[name],
    onChange: customChange,
    onBlur: formik.handleBlur,
    onFocus: () => {
      formik.setFieldValue('formTouched', true);
    },
    required: required
  }, maxLengthAttribute, {
    placeholderText: placeholderText
  })), showError ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'block'
    },
    className: "custom-feedback invalid-feedback"
  }, formik.errors[name]) : '');
}
var _default = exports.default = TextInput;